import React from 'react';

const SearchInput = ({ value, onChange }) => {
  return (
    <div className="sticky top-0 px-3 py-2 border-b border-gray-200 bg-white">
      <input
        type="text"
        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
        placeholder="Search..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
      />
    </div>
  );
};

export default SearchInput;